import { FormField } from '../../../types/form-builder.types';
import { Switch } from '@shondalai/ui-commons';

interface ToggleFieldProps {
  field: FormField;
  value: boolean;
  onChange: (value: boolean) => void;
}

export function ToggleField({ field, value, onChange }: ToggleFieldProps) {
  const config = field.config;
  const disabled = (config as any).disabled;

  return (
    <div className="easyforms-toggle-field">
      <div className="flex items-center gap-3">
        <Switch
          id={field.id}
          checked={value || false}
          onCheckedChange={onChange}
          disabled={disabled}
          className="data-[state=checked]:bg-primary"
        />
        {config.label && (
          <label
            htmlFor={field.id}
            className="text-sm font-medium cursor-pointer select-none"
          >
            {config.label}
          </label>
        )}
      </div>
      {config.helpText && (
        <p className="text-xs text-muted-foreground mt-1">{config.helpText}</p>
      )}
    </div>
  );
}

